import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Label,
  ErrorText,
  InputWrapper,
  StyledInput,
  StyledInputMask,
  IconWrapper,
} from './components/InputStyles';
import Spinner from '../Spinner';
import { useInput } from './hooks/useInput';

const Input = ({
  type = 'text',
  size,
  disabled,
  onChange,
  onEnter,
  value,
  defaultValue,
  placeholder,
  label,
  error,
  icon,
  iconPosition = 'right',
  shape = 'rectangle',
  ariaLabel,
  loading,
  ...rest
}) => {
  const {
    currentValue,
    inputType,
    isMaskedType,
    currentMask,
    showPassword,
    handleChange,
    handleKeyDown,
    toggleShowPassword,
  } = useInput({ type, value, defaultValue, onChange, onEnter, disabled });

  const InputComponent = isMaskedType ? StyledInputMask : StyledInput;

  return (
    <Container>
      {label && <Label disabled={disabled || loading}>{label}</Label>}
      <InputWrapper hasError={!!error} disabled={disabled || loading} shape={shape}>
        {icon && iconPosition === 'left' && type !== 'password' && (
          <IconWrapper disabled={disabled} position="left">
            {icon}
          </IconWrapper>
        )}
        <InputComponent
          mask={currentMask}
          maskChar={isMaskedType ? null : undefined}
          type={isMaskedType ? 'text' : inputType}
          size={size}
          disabled={disabled || loading}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          value={currentValue}
          placeholder={placeholder}
          aria-label={ariaLabel || label}
          {...rest}
        />
        {loading ? (
          <IconWrapper disabled={disabled || loading} position="right">
            <Spinner size={size === 'xs' ? 'xs' : 'sm'} color="brand.primary" />
          </IconWrapper>
        ) : type === 'password' ? (
          <IconWrapper
            disabled={disabled}
            position="right"
            onClick={toggleShowPassword}
            title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
          >
            <i className={`fa fa-eye${showPassword ? '-slash' : ''}`} />
          </IconWrapper>
        ) : (
          icon && iconPosition === 'right' && (
            <IconWrapper disabled={disabled} position="right">
              {icon}
            </IconWrapper>
          )
        )}
      </InputWrapper>
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};

Input.propTypes = {
  type: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onEnter: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  shape: PropTypes.oneOf(['rectangle', 'rounded']),
  ariaLabel: PropTypes.string,
  loading: PropTypes.bool,
};

Input.defaultProps = {
  type: 'text',
  size: 'sm',
  disabled: false,
  onChange: undefined,
  onEnter: undefined,
  value: undefined,
  defaultValue: undefined,
  placeholder: undefined,
  label: undefined,
  error: undefined,
  icon: undefined,
  iconPosition: 'right',
  shape: 'rectangle',
  ariaLabel: undefined,
  loading: false,
};

export default Input;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Input/Input.jsx